<template>
  <SfButton
    variant="ai"
    :disabled="noFiles || exceededMaxFiles"
    @click="emit('analyze')"
  >
    <i class="fa fa-wand-magic-sparkles tw-inline-block" />
    {{ analyzeLabel }}
  </SfButton>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useOCRDocuments } from '../store/use-ocr-documents'

const I18n = useI18n()

const emit =
  defineEmits<{
    analyze: []
  }>()

const analyzeLabel = I18n.t('ai_ocr_requests.steps.analyze')

const documentStore = useOCRDocuments()
const { exceededMaxFiles, noFiles } = storeToRefs(documentStore)
</script>
